import React from 'react';
import { clsx } from '@pushpay/styles';
import { MenuContextProvider } from './menu-context';
import { MenuItem } from './menu-item';
import { useStyles } from './styles';
const arrowKeyIncrements = new Map([['ArrowDown', 1], ['ArrowUp', -1]]);
const menuItemDataAttr = 'data-menu-item';
export const Menu = ({
  displayStyle = 'product',
  className: classNameProp,
  classes: classesProp,
  component,
  focusBehavior = 'browserDefault',
  onItemSelected,
  selectedItem,
  selectionStyle = 'tick',
  ...rest
}) => {
  const containerRef = React.useRef(null);
  const Component = component !== null && component !== void 0 ? component : 'div';
  const classes = useStyles(classesProp, {});
  const className = clsx(classes.root, classNameProp);
  const handleMenuKeyDown = React.useCallback(event => {
    if (focusBehavior === 'arrowKeys' && arrowKeyIncrements.has(event.key)) {
      var _containerRef$current;

      event.preventDefault();
      event.stopPropagation();
      const increment = arrowKeyIncrements.get(event.key);
      const menuItems = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelectorAll(`[${menuItemDataAttr}]`);

      if (increment && menuItems) {
        const menuItemsArray = Array.from(menuItems);
        const menuItemsLength = menuItemsArray.length - 1;
        const currentElementIndex = menuItemsArray.findIndex(el => el === document.activeElement);
        let nextIndex = currentElementIndex + increment;

        if (nextIndex < 0) {
          nextIndex = menuItemsLength;
        } else if (nextIndex > menuItemsLength) {
          nextIndex = 0;
        }

        menuItemsArray[nextIndex].focus();
      }
    }
  }, [focusBehavior]);
  const contextValue = React.useMemo(() => ({
    displayStyle,
    getItemProps: value => {
      const isSelected = value === selectedItem;
      const tabIndex = isSelected || selectedItem === null || focusBehavior === 'browserDefault' ? 0 : -1;
      return {
        isSelected: value === selectedItem,
        onSelected: () => onItemSelected(value),
        props: {
          tabIndex,
          [menuItemDataAttr]: true
        }
      };
    },
    selectedItem,
    selectionStyle
  }), [displayStyle, focusBehavior, onItemSelected, selectedItem, selectionStyle]);
  return /*#__PURE__*/React.createElement(MenuContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, {
    ref: containerRef,
    className: className,
    role: "menu",
    onKeyDown: handleMenuKeyDown
  })));
};
Menu.Item = MenuItem;